import assetPath from '/opt/actions-runner/_work/crate/crate/brewery-packages/xds/xing-logo/src/assets/xing-apple-touch-icon.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')